import React from 'react';

import './switch.scss';

interface Props {
    onChange: (a: any) => void;
    value: boolean;
    id?: string;
    disabled?: boolean;
}

const Switch = ({ onChange, value, id = 'toggle', disabled = false }: Props) => {
    return (
        <div className="switch-container">
            <label className={`switch ${value ? 'isChecked' : ''} ${disabled ? 'isDisabled' : ''}`} htmlFor={id}>
                <input id={id} type="checkbox" onChange={onChange} checked={value} disabled={disabled} />
                <span className="slider" />
            </label>
        </div>
    );
};

export default Switch;
